export const featuresConstants = {
  UPDATE_FEATURE_FLAGS: "UPDATE_FEATURE_FLAGS"
};

export function updateFeatureFlags(featureFlags, dispatch) {
  dispatch({type : featuresConstants.UPDATE_FEATURE_FLAGS, payload: featureFlags});
}

